// @flow

import React, { type Node } from 'react';
import { Space } from './space';
import { Astronaut } from './astronaut';

export function Scene(): Node {
  return (
    <Space>
      <Astronaut />
    </Space>
  );
}
